module.exports = __webpack_public_path__ + "static/media/socialImage-v2.0f9d2dc7.png";